export const i18nRoot = "settings.access_registry.components.access_group_card";
